const API_BASE_URL = import.meta.env.VITE_AUTH_API_URL || 'http://localhost:3005/api/v1';

export interface Invitation {
  id: string;
  email: string;
  organizationName: string;
  roleName: string;
  roleDescription: string;
  status: string;
  expiresAt: string;
  invitationMessage?: string;
  inviter: {
    firstName: string;
    lastName: string;
  };
  createdAt: string;
  updatedAt: string;
}

export interface InvitationListResponse {
  success: boolean;
  data: {
    invitations: Invitation[];
    pagination: {
      page: number;
      limit: number;
      total: number;
    };
  };
  error?: {
    code: string;
    message: string;
  };
}

export interface InvitationListParams {
  page?: number;
  limit?: number;
  status?: 'pending' | 'accepted' | 'expired' | 'cancelled';
  email?: string;
}

export interface ResendInvitationResponse {
  success: boolean;
  message?: string;
  error?: {
    code: string;
    message: string;
  };
}

class InvitationService {
  async getInvitations(params: InvitationListParams = {}): Promise<InvitationListResponse> {
    const searchParams = new URLSearchParams();
    
    if (params.page) searchParams.append('page', params.page.toString());
    if (params.limit) searchParams.append('limit', params.limit.toString());
    if (params.status) searchParams.append('status', params.status);
    if (params.email) searchParams.append('email', params.email);
    
    const queryString = searchParams.toString();
    const url = `${API_BASE_URL}/invitations${queryString ? `?${queryString}` : ''}`;
    
    const response = await fetch(url, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return await response.json();
  }

  async resendInvitation(token: string): Promise<ResendInvitationResponse> {
    const response = await fetch(`${API_BASE_URL}/invitations/${token}/resend`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return await response.json();
  }

  async cancelInvitation(token: string): Promise<ResendInvitationResponse> {
    const response = await fetch(`${API_BASE_URL}/invitations/${token}`, {
      method: 'DELETE',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return await response.json();
  }
}

export const invitationService = new InvitationService();